import game from "./../../game";

//returns the stage
export default function getApp() {
  return [game.game];
}
